import React, { useState } from 'react';
import axios from 'axios';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated, setAuthToken } from '../../utils/auth';
import './Login.css';
import { API_BASE_URL } from '../../utils/apiBase';

const Login = () => {
  const [username, setUsername] = useState('');  // Changed from username to email
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, { username, password });

      // Extract token and role from response
      const { token, role, name, privileges } = response.data;

      if (!token) {
        throw new Error("Login succeeded but no token was returned by the server");
      }

      // Save JWT token to localStorage
      setAuthToken(token, privileges);
      localStorage.setItem("token", token); // ensure this exists
      localStorage.setItem("role", role);
      localStorage.setItem("name", name);
      localStorage.setItem("privileges", JSON.stringify(privileges || [])); // Store user name

      if (!isAuthenticated()) {
        throw new Error("Login token could not be saved in this browser");
      }

      // Redirect based on role
      if (role === "admin") {
        navigate('/dashboard', { replace: true });  // Redirect to admin panel
      } else {
        navigate('/dashboard', { replace: true });  // Redirect to user dashboard
      }
    } catch (err) {
      console.error('Login failed:', err.response?.data || err.message);
      setError(err.response?.data?.msg || err.response?.data?.error || "Invalid username or password");
    }
  };

  return (
    <form onSubmit={handleLogin}>
      <div className="container">
        <div className="card">
          <h1 className="login">Log in</h1>
          <div className="inputBox">
            <input type="text" required onChange={(e) => setUsername(e.target.value)} />
            <span className="user">username</span>
          </div>
          <div className="inputBox passwordBox">
            <input
              type={showPassword ? "text" : "password"}
              required
              onChange={(e) => setPassword(e.target.value)}
            />
            <span>Password</span>
            <button
              type="button"
              className="passwordToggle"
              onClick={() => setShowPassword((current) => !current)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>} {/* Show error message */}
          <button className="enter" type='submit'>Login</button>
          <button
            type="button"
            className="forgot-link"
            onClick={() => navigate('/forgot-password')}
          >
            Forgot Password?
          </button>
        </div>
      </div>
    </form>
  );
};

export default Login;
